/* eslint-disable no-unused-vars */
import axios from 'axios'
import configurations from '../configurations'

// export default axios.create({
//   baseURL: configurations.COUCHDB,
//   withCredentials: configurations.withCredentials
// })

const addMinutes = (minutes) => {
  return new Date(new Date().getTime() + minutes * 60000)
}
const btoa = (myString) => {
  return Buffer.from(myString).toString('base64')
}

const instance = axios.create({
  baseURL: configurations.COUCHDB,
  withCredentials: configurations.withCredentials
})
const cancelTokenSource = axios.CancelToken.source()

instance.interceptors.request.use(config => {
  if (!config.url.includes(`_session`) || config.url.includes(`:3031`)) {
    const apiKey = btoa(`${btoa('mdkgu')}.${btoa(addMinutes(2).getTime().toString())}`)
    config.headers.common['x-api-key'] = apiKey
    config.headers.common['X-Requested-With'] = 'com.menggaris.mdkgu.eservices'
  }
  config.cancelToken = cancelTokenSource.token
  return config
})
export default instance
